var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.482544,
    width: 200,
    height: 200,
    rx: 100,
    fill: "url(#paint0_linear_2269_8008)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7021 66.4399H138.298C139.426 66.4399 140.509 66.8385 141.307 67.5478C142.105 68.2572 142.553 69.2193 142.553 70.2224V130.743C142.553 131.746 142.105 132.708 141.307 133.417C140.509 134.127 139.426 134.525 138.298 134.525H61.7021C60.5735 134.525 59.4912 134.127 58.6931 133.417C57.8951 132.708 57.4468 131.746 57.4468 130.743V70.2224C57.4468 69.2193 57.8951 68.2572 58.6931 67.5478C59.4912 66.8385 60.5735 66.4399 61.7021 66.4399V66.4399ZM100.255 99.2834L72.9702 78.6877L67.4595 84.4522L100.311 109.247L132.57 84.4333L127.004 78.7104L100.26 99.2834H100.255Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2269_8008",
    x1: 50.6473,
    y1: -25.8457,
    x2: 240.142,
    y2: 135.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ead8468a436d8b4997ab143e0307e19d.svg";
export { ForwardRef as ReactComponent };